import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cross--light",
  "use": "cross--light-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" id=\"cross--light\"><defs><style>#cross--light .cls-1{fill:#4f4c65}</style></defs><title>cross_mobile</title><path class=\"cls-1\" d=\"M12 .67L11.33 0 6 5.33.67 0 0 .67 5.33 6 0 11.33l.67.67L6 6.67 11.33 12l.67-.67L6.67 6 12 .67z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/cross--light.svg
// module id = 157
// module chunks = 0